export const clearTrailingSlash = (url) => {
  return url.endsWith('/') ? url.slice(0, -1) : url
}

export const itemIsExist = (item) => item !== null && item !== '' && item !== undefined

export function getResultQuery(routeQuery, additionalQuery = {}) {
  const data = Object.fromEntries(
    Object.entries({ ...routeQuery, ...additionalQuery }).filter((item) => itemIsExist(item[1])),
  )
  return new URLSearchParams(data).toString()
}

export const clearQueryAfterAuth = (query, extra = ['path', 'url']) => {
  const resultQuery = { ...query }
  delete resultQuery.rand_d
  delete resultQuery.hashstr

  extra.forEach((param) => delete resultQuery[param])

  return resultQuery
}

const GAME_EXIT_AD_QUERY_KEYS = new Set([
  'token',
  'path',
  'hashstr',
  'm-message-key',
  'm-message-key-id',
  'm-message-click-id',
  'partner',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'utm_id',
  'modal',
  'a_ssid',
  'mb_uuid',
  'app_id',
  'click_id',
  'stag',
  'qtag',
  'pid',
  'md',
  'source',
  'visit_id',
  'web_id',
  'webid',
  'almirr',
  'sub1',
  'sub2',
  'sub3',
  'fbclid',
  'fbp',
  'old_money_order_uuid',
  'bt-path',
  'ttclid',
])

export function clearGameExitQuery(query, isWebView = false) {
  if (!query) {
    return isWebView ? { return_from_game: true } : query
  }

  const result = Object.fromEntries(Object.entries(query).filter(([key]) => !GAME_EXIT_AD_QUERY_KEYS.has(key)))
  if (isWebView) {
    result.return_from_game = true
  }
  return result
}
